import { BaseProperty } from '@trwl/backend.api';
import { CollapsibleBlock } from '@trwl/widgets/CollapsibleBlock/CollapsibleBlock';

import { DescriptionItem } from './DesctiptionItem';

export const Description = ({
  baseProperties,
}: {
  baseProperties: BaseProperty[];
}) => {
  if (baseProperties.length === 0) return null;
  return (
    <CollapsibleBlock title="Описание" expandedDefault={true}>
      {baseProperties.map((baseProperty) => (
        <DescriptionItem
          key={baseProperty.basePropertyKeyId}
          propertyKey={baseProperty.basePropertyKey}
          propertyValue={baseProperty.basePropertyValue}
        />
      ))}
    </CollapsibleBlock>
  );
};
